export enum GraphQLErrorMessages {
    INVALID_CREDENTIALS = 'Invalid credentials',
}
